import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const ChevronUpIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path d="M12 10.8L8.10005 14.7C7.91672 14.8834 7.68338 14.975 7.40005 14.975C7.11672 14.975 6.88338 14.8834 6.70005 14.7C6.51672 14.5167 6.42505 14.2834 6.42505 14C6.42505 13.7167 6.51672 13.4834 6.70005 13.3L11.3 8.70002C11.5 8.50002 11.7334 8.40002 12 8.40002C12.2667 8.40002 12.5 8.50002 12.7 8.70002L17.3 13.3C17.4834 13.4834 17.575 13.7167 17.575 14C17.575 14.2834 17.4834 14.5167 17.3 14.7C17.1167 14.8834 16.8834 14.975 16.6 14.975C16.3167 14.975 16.0834 14.8834 15.9 14.7L12 10.8Z" fill={color} />
    </svg>
  );
};

export default ChevronUpIcon;
